var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"toggle",class:{toggle_active: _vm.currentValue},on:{"click":_vm.toggle}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }